// French translations
import commonFr from './fr/common.json';
import validationFr from './fr/validation.json';
import errorsFr from './fr/errors.json';
import gridsFr from './fr/grids.json';
import enumsFr from './fr/enums.json';
import voteFr from './fr/pages/vote.json';
import gestionFr from './fr/pages/gestion.json';

// English translations
import commonEn from './en/common.json';
import validationEn from './en/validation.json';
import errorsEn from './en/errors.json';
import gridsEn from './en/grids.json';
import enumsEn from './en/enums.json';
import voteEn from './en/pages/vote.json';
import gestionEn from './en/pages/gestion.json';

export const resources = {
  fr: {
    common: commonFr,
    validation: validationFr,
    errors: errorsFr,
    grids: gridsFr,
    enums: enumsFr,
    vote: voteFr,
    gestion: gestionFr,
  },
  en: {
    common: commonEn,
    validation: validationEn,
    errors: errorsEn,
    grids: gridsEn,
    enums: enumsEn,
    vote: voteEn,
    gestion: gestionEn,
  },
} as const;

export type SupportedLanguage = keyof typeof resources;
export type Namespace = keyof typeof resources.fr;

export const supportedLanguages: SupportedLanguage[] = ['fr', 'en'];
export const defaultLanguage: SupportedLanguage = 'fr';
export const defaultNamespace: Namespace = 'common';
